/**
 * Compact info about a course participant (used in the multi-selects and in the course summary in the collapsible table)
 */

import React from 'react'
import {useStyles} from "./CourseParticipantCard.css";
import {Chip} from "@mui/material";
import {Delete} from "@mui/icons-material";
import {Tooltip} from "@mui/material";
import {useIntl} from "react-intl";
import UserProfilePicture from "../../../users/overview/UserProfilePicture";

const CourseParticipantCard = ({user, ...props}) => {
    const classes = useStyles()

    // Internationalization for simple strings
    const intl = useIntl();

    if (user.deleted === true) {
        return <Chip {...props} className={classes.chip} label={
            <Tooltip title={intl.formatMessage({
                id: 'app.courses.edit.tooltip.deletedUser',
                defaultMessage: 'Course participant with ID {uid} has been deleted from the system.'
            }, {uid: user.uid})}>
                <div className={classes.row}>

                    {/* "Deleted" icon */}
                    <div>
                        <Delete/>
                    </div>

                    {/* "Deleted user" info */}
                    <div className={classes.userInfo}>
                        Deleted User
                    </div>
                </div>
            </Tooltip>
        }/>
    }

    return (
        <Chip {...props} className={classes.chip} label={
            <div className={classes.row}>

                {/* Profile avatar */}
                <div>
                    <UserProfilePicture user={user} height={40} width={40}/>
                </div>

                {/* Compact user info */}
                <div className={classes.userInfo}>
                    <div className={classes.name}>
                        {user.firstName + ' ' + user.secondName}
                    </div>
                    <div className={classes.email}>
                        {user.email}
                    </div>
                </div>
            </div>
        }/>
    )
}

export default CourseParticipantCard
